<app-dynamic-form [(form)]="form" [questions]="questions"></app-dynamic-form>

@if (this.form.get('profile').value === 'Simple') {
  <div>
    <p><span class="fw-bold">L'utilisateur simple</span> peut :</p>
    <ul>
      <li>accéder à ses tickets et à ceux déjà créés par les autres membres de sa structure</li>
      <li>consulter le nombre d'heures restantes sur le carnet de temps</li>
      <li>accéder aux ressources</li>
      <li>consulter les informations en direct</li>
      <li>accéder aux outils mis à disposition</li>
      <li>ajouter des sites en favoris</li>
    </ul>
  </div>
}

@if (this.form.get('profile').value === 'Referent') {
  <div>
    <p><span class="fw-bold">L'utilisateur référent Portail</span> fait office de contact principal au sein de la
  structure.<br/>Il peut comme un utilisateur simple :</p>
  <ul>
    <li>accéder à ses tickets et à ceux déjà créés par les autres membres de sa structure</li>
    <li>consulter le nombre d'heures restantes sur le carnet de temps</li>
    <li>accéder aux ressources</li>
    <li>consulter les informations en direct</li>
    <li>accéder aux outils mis à disposition</li>
    <li>ajouter des sites en favoris</li>
  </ul>
  <p>Il peut, également :</p>
  <ul>
    <li>demander l'ajout, la suppression et la modification des utilisateurs sur le portail</li>
    <li>voir le calendrier des prestations qui sont planifiées</li>
    <li>accéder à la page "contrats"</li>
  </ul>
</div>
}
